import { TextField as MuiTextField, TextFieldProps, styled, MenuItem } from '@mui/material'
import React, { FC } from 'react'

import { IsItem } from '../interfaces/IsItem'

const StyledTextField = styled((props: TextFieldProps) => <MuiTextField {...props} />)(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    minHeight: '48px',
    menuPaper: {
      maxHeight: 100,
    },

    marginBottom: '3px',
  }),
)

interface Props {
  items: IsItem[]
  [otherProps: string]: any
}

const TextField: FC<Props> = ({ items, ...otherProps }) => {
  return (
    <StyledTextField
      {...otherProps}
      SelectProps={{
        MenuProps: {
          style: { height: '200px', minHeight: 'calc(10% - 32px)' },
        },
      }}
    >
      {items.map((item) => (
        <MenuItem key={item.id} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </StyledTextField>
  )
}

export default TextField
